import './index_mWeb.css';
import { HeaderWithTimer, RouteWrapper } from '../../../component';
import ContestTab from '../contest_tab';
import { HomeTabBar } from '../../component';
import SwipeableViews from 'react-swipeable-views';
import { useLink } from 'react-router-stack';
import { useDispatch, useSelector } from 'react-redux';
import { updateUserInfo } from '../../../actions/user-actions-types';
import ScreenBackgroundWrapper from '../../../component/screen_background_wrapper';
import constants from '../../../constants';
import MyTeamsList from '../my_teams_tab';
import { MyContestTab } from '..';

const HomeTabMWeb = ({
  gameType,
  matchItem,
  onCalledDeadline,
  fantasyCricketMyTeamsList,
  fantasyFootballMyTeamsList,
  fantasyCricketMyContestList,
  fantasyFootballMyContestList,
  activeTab,
  onChangeTab,
  routes,
  onChangeIndex
}: any) => {
  const user = useSelector((state: any) => state.user);
  const dispatch = useDispatch();
  const { teamName = '' } = user;
  const navigate = useLink();

  const onPressBack = () => {
    try {
      if (user?.isDirectContest) {
        dispatch(updateUserInfo({ ...user, isDirectContest: false }));
        navigate.push('/fantasy_home');
      } else {
        navigate.goBackView();
      }
    } catch (err) {
      navigate.go(-1);
    }
  };

  return (
    <RouteWrapper>
      <ScreenBackgroundWrapper>
        <HeaderWithTimer
          onPressBack={onPressBack}
          matchItem={matchItem}
          onCalledDeadline={onCalledDeadline}
          teamName={teamName}
          isCreateTeam={false}
          //   gameName={gameName}
        />
        <HomeTabBar
          myTeamCount={
            gameType === constants.GameType.FANTASY_CRICKET
              ? fantasyCricketMyTeamsList[matchItem['_id']]?.length
              : gameType === constants.GameType.FANTASY_FOOTBALL
              ? fantasyFootballMyTeamsList[matchItem['_id']]?.length
              : 0
          }
          myContestsCount={
            gameType === constants.GameType.FANTASY_CRICKET
              ? fantasyCricketMyContestList[matchItem['_id']]?.length
              : gameType === constants.GameType.FANTASY_FOOTBALL
              ? fantasyFootballMyContestList[matchItem['_id']]?.length
              : 0
          }
          activeTab={activeTab}
          onChangeTab={onChangeTab}
          routes={routes}
        />
        <SwipeableViews
          style={{ height: '100%' }}
          disableLazyLoading={true}
          index={activeTab}
          onChangeIndex={onChangeIndex}>
          <ContestTab />
          <MyContestTab />
          <MyTeamsList />
        </SwipeableViews>
      </ScreenBackgroundWrapper>
    </RouteWrapper>
  );
};

export default HomeTabMWeb;
